import React, { useState, useRef, useEffect } from 'react';
import { Dropdown, Checkbox } from 'tea-component';
import { useIntl } from 'umi';
import {
  ACCUMULATED_TEXT,
  ACCUMULATED_VALUE,
} from './constant';

import './index.scss';

/**
 * 需求描述
 * 1. 交互描述
 *    点击Accumulate之后, 取消下面所有的多选;
 *    点击了多选之后, 才能取消上面的单选Accumulate;
 *    如果Separated的值都没有选, 则自动选中 Accumulate
 * 2. 用户选择后， 要按照下拉顺序在页面上显示选项值， 而不是用户点击顺序
 * 3. 在下拉框关闭后，发起请求
 * 4. 点击展开下拉框
 */

function DimensionAccumulate(props: any) {
  const { value = [], options = [], onChange, onClose, className = '' } = props;
  const { formatMessage } = useIntl();
  // const [radioValue, setRadioValue] = useState(true);
  const [checkValue, setCheckValue] = useState([]);
  // Dropdown 挂载的类名. Date.now是为了防止同一个页面使用了多个本组件, 造成挂载位置错误.
  const bindClassName = useRef(
    `dimension-accumulate-${  Date.now().toString(36)}`,
  );
  useEffect(() => {
    // setRadioValue(value.includes(ACCUMULATED_VALUE));
    setCheckValue(value);
  }, [value]);
  // 单选Accumulate
  // const handleRadioChange = (value) => {
  //   value && onChange([ACCUMULATED_VALUE]);
  // };
  // 多选Separated
  const handleCheckoutChange = (value) => {
    // onChange(value.length === 0 ? [ACCUMULATED_VALUE] : value);
    onChange(value);
  };

  // 渲染
  const renderButton = () => {
    let content = '';
    if (value?.length > 0) {
      content = options.reduce((acc, opt) => {
        if (value.includes(opt.value)) content += `${opt.text  }, `;
        return content;
      }, '');
      content = content?.substring(0, content.length - 2); // 去掉结尾逗号
    } else {
      content = formatMessage({ id: 'common_Accumulated' });
    }

    return (
      <div className="selector-multiple__header">
        <span className="tea-text-weak">
          {formatMessage({ id: 'common_Dimension' })}{' '}
        </span>
        &nbsp;
        {content}
      </div>
    );
  };
  return (
    <Dropdown
      button={renderButton()}
      onClose={onClose}
      appearance="button"
      clickClose={false}
      closeOnScroll={false}
      positionFixed={false}
      boxClassName="selector-multiple__dropdown dbd-selector"
      overlayClassName={'dbd_selector-multiple__dropdown-overlay is-dimension'}
      className={`${bindClassName.current} selector-multiple is-dimension overall-conext-select ${className}`}
      popupContainer={() => document.querySelector(`.${bindClassName.current}`)}
      matchButtonWidth
    >
      <div className="selector-multiple__dropdown-inner">
        {/* <div className='selector-multiple__dropdown-header'>
          <Radio value={radioValue} onChange={handleRadioChange}>
            {formatMessage({id: "common_by_Date"})}
          </Radio>
        </div> */}
        <div className="list-container">
          {/* <div className='title'>
            <span className='label'>{formatMessage({id: "common_Separated"})}</span>
          </div> */}
          <Checkbox.Group
            layout="column"
            value={checkValue}
            className="list"
            onChange={handleCheckoutChange}
          >
            {options?.map((item) => (
              <Checkbox
                key={item.value}
                name={item.value}
                disabled={item.disabled && value.includes(item.value)}
              >
                <span dangerouslySetInnerHTML={{ __html: `${item.text}` }} />
              </Checkbox>
            ))}
          </Checkbox.Group>
        </div>
      </div>
    </Dropdown>
  );
}

export default DimensionAccumulate;
export { ACCUMULATED_TEXT, ACCUMULATED_VALUE };
